const LAYOUT_MENU_ITEM_IDS = {
  PressReleases: 1,
  AboutZillow: 2,
  Impact: 3,
  Investors: 4,
  Careers: 5
};
const LAYOUT_MENU_ITEMS = [
  // Press Releases - direct link
  {
    parent: 0,
    id: LAYOUT_MENU_ITEM_IDS.PressReleases,
    title: {
      rendered: "Press Releases"
    },
    url: "/news/press-releases/"
  },
  // About Zillow - standard dropdown
  {
    parent: 0,
    id: LAYOUT_MENU_ITEM_IDS.AboutZillow,
    title: {
      rendered: "About Zillow"
    },
    url: "#"
  },
  {
    parent: LAYOUT_MENU_ITEM_IDS.AboutZillow,
    id: "about-us",
    title: {
      rendered: "About Us"
    },
    url: "/news/about/"
  },
  {
    parent: LAYOUT_MENU_ITEM_IDS.AboutZillow,
    id: "brands-businesses",
    title: {
      rendered: "Brands & Businesses"
    },
    url: "/news/our-business/"
  },
  {
    parent: LAYOUT_MENU_ITEM_IDS.AboutZillow,
    id: "our-leadership",
    title: {
      rendered: "Our Leadership"
    },
    url: "/news/our-leaders/"
  },
  {
    parent: LAYOUT_MENU_ITEM_IDS.AboutZillow,
    id: "our-story",
    title: {
      rendered: "Our Story"
    },
    url: "/news/our-story/"
  },
  // Impact - 3-column mega menu using `columns` property
  {
    parent: 0,
    id: LAYOUT_MENU_ITEM_IDS.Impact,
    title: {
      rendered: "Impact"
    },
    url: "#",
    columns: [{
      heading: "Consumer Advocacy",
      links: [{
        title: "Overview",
        url: "/news/advocacy/"
      }, {
        title: "Transparency",
        url: "/news/advocacy/transparency/"
      }, {
        title: "Rentals",
        url: "/news/advocacy/rentals/"
      }, {
        title: "Real Estate Rights",
        url: "/news/advocacy/real-estate-rights/"
      }, {
        title: "Stories",
        url: "/news/advocacy/stories/"
      }, {
        title: "Fairness & Advocacy News",
        url: "/news/fairness-advocacy/"
      }]
    }, {
      heading: "Sustainability",
      links: [{
        title: "Sustainability Report",
        url: "/news/sustainability/"
      }, {
        title: "Environmental Sustainability",
        url: "/news/sustainability/environmental-sustainability/"
      }, {
        title: "Responsible Business Practices",
        url: "/news/sustainability/responsible-business-practices/"
      }, {
        title: "Our AI Principles",
        url: "/news/sustainability/ai-principles/"
      }, {
        title: "Employees & Culture",
        url: "/news/sustainability/employees-culture/"
      }, {
        title: "Engagement & Belonging",
        url: "https://www.zillow.com/careers/engagement-and-belonging/",
        target: "_blank"
      }]
    }, {
      heading: "Social Impact",
      description: "Explore how Zillow is driving real progress toward a more affordable and accessible housing market.",
      links: [{
        title: "Explore our impact",
        url: "/news/social-impact/"
      }]
    }]
  },
  // Investors - direct link (external)
  {
    parent: 0,
    id: LAYOUT_MENU_ITEM_IDS.Investors,
    title: {
      rendered: "Investors"
    },
    url: "https://investors.zillowgroup.com/investors/overview/default.aspx",
    target: "_blank"
  },
  // Careers - direct link (external)
  {
    parent: 0,
    id: LAYOUT_MENU_ITEM_IDS.Careers,
    title: {
      rendered: "Careers"
    },
    url: "https://www.zillow.com/careers/",
    target: "_blank"
  }
];
const HEADER_CTAS = {
  primary: {
    label: "Press Inquiries",
    url: "mailto:press@zillow.com"
  },
  secondary: {
    label: "Subscribe",
    url: "#subscribe"
  }
};
const FOOTER_COLUMNS = [{
  title: "News",
  description: "",
  links: [{
    title: "Company News",
    url: "/news/company-news/"
  }, {
    title: "Research",
    url: "/research/"
  }, {
    title: "Product Innovation",
    url: "/news/product-innovation/"
  }, {
    title: "Industry Partnerships",
    url: "/news/industry-partnerships/"
  }, {
    title: "Fairness & Advocacy",
    url: "/news/fairness-advocacy/"
  }, {
    title: "Zillow Culture",
    url: "/news/culture/"
  }]
}, {
  title: "Our Brands",
  description: "",
  links: [{
    title: "Zillow",
    url: "https://www.zillow.com/",
    target: "_blank"
  }, {
    title: "Trulia",
    url: "https://www.trulia.com/",
    target: "_blank"
  }, {
    title: "StreetEasy",
    url: "https://streeteasy.com/",
    target: "_blank"
  }, {
    title: "Hotpads",
    url: "https://hotpads.com/",
    target: "_blank"
  }, {
    title: "Follow Up Boss",
    url: "https://www.followupboss.com/",
    target: "_blank"
  }, {
    title: "Aryeo",
    url: "https://www.aryeo.com/",
    target: "_blank"
  }, {
    title: "Zillow Rentals",
    url: "https://www.zillow.com/rental-manager/",
    target: "_blank"
  }, {
    title: "Zillow Home Loans",
    url: "https://www.zillow.com/homeloans/",
    target: "_blank"
  }, {
    title: "Zillow Pro",
    url: "https://www.zillow.com/agents/zillow-pro/",
    target: "_blank"
  }, {
    title: "Zillow Premier Agent",
    url: "https://www.zillow.com/premier-agent/",
    target: "_blank"
  }, {
    title: "Zillow Closing",
    url: "https://www.zillow.com/zillow-closing/",
    target: "_blank"
  }]
}, {
  title: "Policies & Disclosures",
  description: "",
  links: [{
    title: "Terms of Use",
    url: "https://www.zillow.com/corporate/terms-of-use/",
    target: "_blank"
  }, {
    title: "Privacy Policy",
    url: "https://www.zillow.com/corporate/zg-privacy-notice/",
    target: "_blank"
  }, {
    title: "Corporate Policies",
    url: "https://www.zillow.com/corporate/policies/",
    target: "_blank"
  }, {
    title: "Security Disclosure",
    url: "https://www.zillow.com/corporate/security-disclosure/",
    target: "_blank"
  }, {
    title: "Supplier Code of Conduct",
    url: "https://www.zillow.com/corporate/supplier-code-of-conduct/",
    target: "_blank"
  }]
}];
export {
  FOOTER_COLUMNS,
  HEADER_CTAS,
  LAYOUT_MENU_ITEMS,
  LAYOUT_MENU_ITEM_IDS
};
